import React from 'react';
import ListContent from '../../elements/ListContent';
export default function index(props) {
  return <ListContent {...props}></ListContent>;
}
